// NOTE this file can be edited by hand, but it is also appended to by the migration:create command.
// It's important that every migration is exported from here with the proper name. We'd simplify
// this with kysely's FileMigrationProvider, but it doesn't play nicely with the build process.

export * as _20230309T045948368Z from './20230309T045948368Z-init.js'
export * as _20230408T152211201Z from './20230408T152211201Z-notification-init.js'
export * as _20230417T210628672Z from './20230417T210628672Z-moderation-init.js'
export * as _20230420T211446071Z from './20230420T211446071Z-did-cache.js'
export * as _20230427T194702079Z from './20230427T194702079Z-notif-record-index.js'
export * as _20230605T144730094Z from './20230605T144730094Z-post-profile-aggs.js'
export * as _20230607T211442112Z from './20230607T211442112Z-feed-generator-init.js'
export * as _20230608T155101190Z from './20230608T155101190Z-algo-whats-hot-view.js'
export * as _20230608T201813132Z from './20230608T201813132Z-mute-lists.js'
export * as _20230608T205147239Z from './20230608T205147239Z-mutes.js'
export * as _20230609T153623961Z from './20230609T153623961Z-blocks.js'
export * as _20230609T232122649Z from './20230609T232122649Z-actor-deletion-indexes.js'
export * as _20230610T203555962Z from './20230610T203555962Z-suggested-follows.js'
export * as _20230611T215300060Z from './20230611T215300060Z-actor-state.js'
export * as _20230620T161134972Z from './20230620T161134972Z-post-langs.js'
export * as _20230627T212437895Z from './20230627T212437895Z-optional-handle.js'
export * as _20230629T220835893Z from './20230629T220835893Z-remove-post-hierarchy.js'
export * as _20230703T045536691Z from './20230703T045536691Z-feed-and-label-indices.js'
export * as _20230720T164800037Z from './20230720T164800037Z-posts-cursor-idx.js'
export * as _20230807T035309811Z from './20230807T035309811Z-feed-item-delete-invite-for-user-idx.js'
export * as _20230808T172902639Z from './20230808T172902639Z-repo-rev.js'
export * as _20230810T203349843Z from './20230810T203349843Z-action-duration.js'
export * as _20230817T195936007Z from './20230817T195936007Z-native-notifications.js'
export * as _20230830T205507322Z from './20230830T205507322Z-suggested-feeds.js'
export * as _20230904T211011773Z from './20230904T211011773Z-block-lists.js'
export * as _20230906T222220386Z from './20230906T222220386Z-thread-gating.js'
export * as _20230920T213858047Z from './20230920T213858047Z-add-tags-to-post.js'
export * as _20230929T192920807Z from './20230929T192920807Z-record-cursor-indexes.js'
export * as _20231003T202833377Z from './20231003T202833377Z-create-moderation-subject-status.js'
export * as _20231220T225126090Z from './20231220T225126090Z-blob-takedowns.js'
export * as _20240124T023719200Z from './20240124T023719200Z-tagged-suggestions.js'
export * as _20240226T225725627Z from './20240226T225725627Z-labelers.js'
export * as _20240530T170337073Z from './20240530T170337073Z-account-deactivation.js'
export * as _20240606T171229898Z from './20240606T171229898Z-thread-mutes.js'
export * as _20240606T222548219Z from './20240606T222548219Z-starter-packs.js'
export * as _20240719T203853939Z from './20240719T203853939Z-priority-notifs.js'
export * as _20240723T220700077Z from './20240723T220700077Z-quotes-post-aggs.js'
export * as _20240723T220703655Z from './20240723T220703655Z-quotes.js'
export * as _20240801T193939827Z from './20240801T193939827Z-post-gate.js'
export * as _20240808T224251220Z from './20240808T224251220Z-post-gate-flags.js'
export * as _20240829T211238293Z from './20240829T211238293Z-simplify-actor-sync.js'
export * as _20240831T134810923Z from './20240831T134810923Z-pinned-posts.js'
export * as _20241114T153108102Z from './20241114T153108102Z-add-starter-packs-name.js'
export * as _20250116T222618297Z from './20250116T222618297Z-post-embed-video.js'
export * as _20250207T174822012Z from './20250207T174822012Z-add-label-exp.js'
export * as _20250404T163421487Z from './20250404T163421487Z-verifications.js'
export * as _20250526T023712742Z from './20250526T023712742Z-like-repost-via.js'
export * as _20250528T221913281Z from './20250528T221913281Z-add-record-tags.js'
export * as _20250602T190357447Z from './20250602T190357447Z-add-private-data.js'
export * as _20250611T140649895Z from './20250611T140649895Z-add-activity-subscription.js'
export * as _20250627T025331240Z from './20250627T025331240Z-add-actor-age-assurance-columns.js'
export * as _20250812T183735692Z from './20250812T183735692Z-add-bookmarks.js'
export * as _20250813T174955711Z from './20250813T174955711Z-add-post-agg-bookmarks.js'
export * as _20251120T004738098Z from './20251120T004738098Z-update-actor-age-assurance-v2.js'
export * as _20260112T133951271Z from './20260112T133951271Z-add-drafts.js'
export * as _20260604T224952774Z from './20260604T224952774Z-post-embed-gallery-image.js'
export * as _20260618T200000000Z from './20260618T200000000Z-add-mute-scope.js'
export * as _20260729T223157563Z from './20260729T223157563Z-add-op-thread-reply.js'
export * as _20260819T170000000Z from './20260819T170000000Z-add-like-subject-sort-index.js'
